import { render } from "./InterviewCard.vue?vue&type=template&id=fd1ca832&scoped=true"
import script from "./InterviewCard.vue?vue&type=script&lang=js"
export * from "./InterviewCard.vue?vue&type=script&lang=js"

import "./InterviewCard.vue?vue&type=style&index=0&id=fd1ca832&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd1ca832"]])

export default __exports__